document.addEventListener('DOMContentLoaded', () => {
  const isOutbound = (url) => {
    try {
      const componentUrl = new URL(url)
      return componentUrl.host.replace('assets.', '') !== window.location.host
    } catch (error) {
      return false
    }
  }

  function getTextContentOrDefault(element, defaultValue) {
    return (element && element.innerText.trim()) || defaultValue
  }

  function getSection() {
    let section = ''

    const relatedContentTitle = document.querySelector('.related-content')
    if (relatedContentTitle) {
      section = 'related content'
    } else {
      const youMayAlsoLikeTitle = document.body.textContent || document.body.innerText
      if (youMayAlsoLikeTitle.includes('You may also like:')) {
        section = 'you may also like'
      } else {
        section = 'feed página'
      }
    }

    return section
  }

  const pageType = window.location.href.includes('gateway-pages') ? 'gateway-pages' : 'content-page'

  const shareElements = document.querySelectorAll('.social-share')
  if (shareElements) {
    shareElements.forEach((element) => {
      element.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'share_this',
          label: element.getAttribute('id').replace('link-share-', ''),
          page_type: pageType
        })
      })
    })
  }

  const swiperSlideCardElements = document.querySelectorAll('.swiper-slide-tagging')
  if (swiperSlideCardElements) {
    swiperSlideCardElements.forEach((element) => {
      element.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: element.querySelector('.title').getAttribute('title'),
          section: element.getAttribute('section'),
          component_type: 'card',
          link_url: element.getAttribute('href'),
          outbound: isOutbound(element.getAttribute('href'))
        })
      })
    })
  }

  const fullBannerElements = document.querySelectorAll('.full-banner-tagging')
  if (fullBannerElements) {
    fullBannerElements.forEach((element) => {
      element.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: element.getAttribute('title-tagging'),
          section: 'banner',
          component_type: 'button',
          link_url: element.getAttribute('href'),
          outbound: isOutbound(element.getAttribute('href'))
        })
      })
    })
  }

  const highlightGridElements = document.querySelectorAll('.highlight-tagging')
  if (highlightGridElements) {
    highlightGridElements.forEach((element) => {
      element.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: element.getAttribute('title-tagging'),
          section: 'highlight',
          component_type: 'card',
          link_url: element.getAttribute('href'),
          outbound: isOutbound(element.getAttribute('href'))
        })
      })
    })
  }

  const bannerDynamicElements = document.querySelectorAll('.banner-dynamic-tagging')
  if (bannerDynamicElements) {
    bannerDynamicElements.forEach((element) => {
      const titles = element.querySelectorAll('.title')
      let title = titles != null ? titles[0].innerText : 'BannerDynamic'
      const highlight = titles != null ? titles[0].innerText : 'BannerDynamic'
      const tamanho = titles != null ? titles.length : 0
      if (tamanho >= 2) {
        title = titles[1].innerText
      }
      element.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: title,
          section: highlight,
          component_type: 'button',
          link_url: element.querySelector('.button').getAttribute('href'),
          outbound: isOutbound(element.querySelector('.button').getAttribute('href'))
        })
      })
    })
  }

  const eventCarouselElements = document.querySelectorAll('.event-carousel-tagging')
  if (eventCarouselElements.length > 0) {
    eventCarouselElements.forEach((eventCarouselElement) => {
      const eventCarouselCardElements = eventCarouselElement.querySelectorAll('.event-card')

      eventCarouselCardElements.forEach((element) => {
        element.addEventListener('click', () => {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'click',
            name: element.querySelector('.event-card__title').innerText,
            section: eventCarouselElement.querySelector('.event-carousel__title').innerText,
            component_type: 'button',
            link_url: element.querySelector('.event-card__cta a').getAttribute('href'),
            outbound: isOutbound(element.querySelector('.event-card__cta a').getAttribute('href'))
          })
        })
      })
    })
  }

  const mostPopularContainer = document.querySelector('.most-popular')
  if (mostPopularContainer) {
    const links = mostPopularContainer.querySelectorAll('a')
    links.forEach((link, index) => {
      link.addEventListener('click', () => {
        const titleElement = link.querySelector('.title')
        const name = titleElement ? titleElement.getAttribute('title') : null
        const urlTarget = link.getAttribute('href')

        window.dataLayer.push({
          event: 'click',
          name,
          section: 'Most Popular',
          component_type: 'link',
          link_url: urlTarget,
          outbound: isOutbound(urlTarget),
          position: index + 1
        })
      })
    })
  }

  const accordionElements = document.querySelectorAll('.droptext')
  if (accordionElements) {
    accordionElements.forEach((element) => {
      element.addEventListener('click', () => {
        const sectionName = element.closest('.nt-faq').getAttribute('section')
        const title = element.querySelector('.droptext__title').innerText
        window.dataLayer.push({
          event: 'click',
          name: title,
          section: sectionName,
          component_type: 'accordion',
          outbound: false
        })
      })
    })
  }

  const downloadPDFElements = document.querySelectorAll('.pdf-list__item, .button--download-document')
  if (downloadPDFElements) {
    downloadPDFElements.forEach(downloadPDFElement => {
      downloadPDFElement.addEventListener('click', () => {
        const label = downloadPDFElement ? downloadPDFElement.innerText : 'Sem label'

        const closestPdfList = downloadPDFElement.closest('.pdf-list')
        const section = closestPdfList ? 'certificações' : 'download'

        const getAuthor = document.getElementsByClassName('authors')[0]
        const author = (getAuthor && getAuthor.innerText.trim()) || 'Sem autor'

        const fileUrl = downloadPDFElement.getAttribute('href')
        const fileExtension = fileUrl ? fileUrl.split('.').pop().toLowerCase() : ''

        const pageTitle = document.title || 'Sem título'

        const name = section === 'certificações' ? label : pageTitle

        window.dataLayer.push({
          event: 'file_download',
          label,
          section,
          author,
          file_extension: fileExtension,
          link_url: fileUrl,
          name
        })
      })
    })
  }

  const fileDownloadButton = document.querySelector('#btn-download-pdf')
  if (fileDownloadButton) {
    fileDownloadButton.addEventListener('click', () => {
      const pageTitle = document.title || ''
      const fileUrl = fileDownloadButton.getAttribute('href')
      const fileExtension = fileUrl ? fileUrl.split('.').pop().toLowerCase() : ''
      const label = fileDownloadButton.innerText || ''

      window.dataLayer.push({
        event: 'file_download',
        name: pageTitle,
        section: 'contato',
        author: 'Sem autor',
        file_extension: fileExtension,
        link_url: fileUrl,
        label
      })
    })
  }

  const footer = document.querySelector('footer')
  if (footer) {
    const footerLinksColumns = footer.querySelectorAll('.links')
    footerLinksColumns.forEach(column => {
      const columnName = column.querySelector('.category')
      const links = column.querySelectorAll('a')
      links.forEach(link => {
        link.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'click',
            name: columnName ? `${columnName.innerText}-${link.innerText}` : `footercolumn-${link.innerText}`,
            section: 'footer',
            component_type: 'link',
            link_url: link.href,
            outbound: isOutbound(link.href)
          })
        })
      })
    })
  }

  const anchorTags = document.querySelectorAll('.c-text a')
  const anchorQuantity = anchorTags.length
  if (anchorTags) {
    anchorTags.forEach((anchor, index) => {
      const text = anchor.textContent.trim()
      const href = anchor.href
      let clickedAnchors = 0

      anchor.addEventListener('click', () => {
        clickedAnchors += 1

        window.dataLayer.push({
          event: 'internal_click',
          label: text,
          position: index,
          quantity_total: anchorQuantity,
          quantity_clicked: clickedAnchors,
          outbound: isOutbound(href)
        })
      })
    })
  }

  const filterTags = document.querySelectorAll('.filter-tags-tagging a')
  if (filterTags) {
    filterTags.forEach(link => {
      link.addEventListener('click', () => {
        const tagName = link.textContent.toLowerCase()

        window.dataLayer.push({
          event: 'filter_subtopics',
          label: tagName || '',
          link_url: link.href,
          outbound: isOutbound(link.href)
        })
      })
    })
  }

  const getReadMoreArticles = document.querySelectorAll('#link-article-readmore')
  getReadMoreArticles.forEach((article, index) => {
    const readMoreButton = article.querySelector('.read-more')
    const title = getTextContentOrDefault(article.querySelector('.title'), 'Sem título')
    const category = getTextContentOrDefault(article.querySelector('.category'), 'Sem categoria')
    const typeTag = getTextContentOrDefault(article.querySelector('.type-tag'), 'Sem tag')
    const getImage = article.querySelector('.image')
    const hasThumbnail = getImage ? getImage.style.backgroundImage !== '' : false

    article.addEventListener('click', (event) => {
      if (event.target === readMoreButton) return

      window.dataLayer.push({
        event: 'click',
        label: title,
        page_type: pageType,
        section: getSection(),
        category,
        thumbnail: hasThumbnail,
        position: index,
        type_tag: typeTag
      })
    })

    if (readMoreButton) {
      readMoreButton.addEventListener('click', (event) => {
        event.stopPropagation()

        window.dataLayer.push({
          event: 'click_more',
          label: title,
          page_type: pageType,
          section: getSection(),
          category,
          thumbnail: hasThumbnail,
          position: index,
          type_tag: typeTag
        })
      })
    }
  })

  const getCatalogCards = document.querySelectorAll('.catalog .card')
  if (getCatalogCards) {
    getCatalogCards.forEach((card, index) => {
      const title = getTextContentOrDefault(card.querySelector('.title'), 'Sem título')
      const typeTag = getTextContentOrDefault(card.querySelector('.text--selected'), 'Sem tag')
      const category = getTextContentOrDefault(card.querySelector('.text--category'), 'Sem categoria')
      const getImage = card.querySelector('.card__image')
      const hasThumbnail = getImage ? getImage.getAttribute('data-bgset') !== '' : false

      card.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          label: title,
          page_type: pageType,
          section: getSection(),
          category,
          thumbnail: hasThumbnail,
          position: index,
          type_tag: typeTag
        })
      })
    })
  }

  const getNbBannerMedia = document.querySelectorAll('.nb-banner-media')
  if (getNbBannerMedia) {
    getNbBannerMedia.forEach((card, index) => {
      const title = getTextContentOrDefault(card.querySelector('.nb-banner-media__title'), 'Sem título')
      const description = getTextContentOrDefault(card.querySelector('.nb-banner-media__subtitle'), 'Sem descrição')
      const getImage = card.querySelector('.nb-banner-media')
      const hasThumbnail = getImage ? getImage.style.backgroundImage !== '' : false
      const bannerButton = card.querySelector('.nb-banner-media__button')

      if (bannerButton) {
        bannerButton.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'click',
            label: title,
            page_type: pageType,
            section: getSection(),
            thumbnail: hasThumbnail,
            position: index,
            description,
          })
        })
      }
    })
  }
})
